import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles, categories, siteInfo } from '@/mocks/data';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 5);
  const newArticles = articles.filter((a) => a.isNew).slice(0, 3);
  const featuredArticle = articles[0];
  const secondaryFeatured = articles.slice(1, 3);
  const recentArticles = articles.slice(3, 9);

  const landingSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteInfo.url}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: siteInfo.url,
    email: siteInfo.email,
    telephone: siteInfo.phone,
    address: {
      '@type': 'PostalAddress',
      streetAddress: siteInfo.address,
      addressLocality: '北京',
      addressRegion: '北京',
      addressCountry: 'CN',
    },
  };

  const handleCategoryClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <SEOHead
        title="明星黑料大全｜最新娱乐圈劲爆内幕揭秘"
        description="汇聚最新最全明星黑料，深度揭秘娱乐圈内幕、丑闻事件与真相追踪。从流量小生到顶级流量，明星黑料一网打尽，带你看清光鲜背后的真实一面。"
        keywords="明星黑料,娱乐圈黑料,明星丑闻,艺人内幕,明星负面新闻,娱乐圈内幕揭秘,明星真实面目"
        canonicalUrl={siteInfo.url}
        ogImage="https://readdy.ai/api/search-image?query=Entertainment%20news%20website%20homepage%2C%20dramatic%20dark%20background%20with%20red%20accents%2C%20celebrity%20gossip%20theme%2C%20modern%20web%20design%2C%20professional%20media%20layout&width=1200&height=630&seq=home-og&orientation=landscape"
        schemaJson={{ ...landingSchema, ...orgSchema }}
      />
      <Navbar />

      <main className="min-h-screen">
        {/* Hero Section */}
        <header className="relative h-[500px] md:h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20city%20night%20scene%20with%20red%20neon%20lights%2C%20urban%20street%20atmosphere%2C%20mysterious%20vibe%2C%20entertainment%20district%2C%20cinematic%20composition%2C%20noir%20style%2C%20professional%20photography&width=1600&height=900&seq=hero-bg&orientation=landscape"
            alt="明星黑料大全"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/30 to-foreground-950/80"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
              <div className="max-w-2xl">
                <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50 mb-4">
                  每日更新 · 独家爆料
                </span>
                <h1 className="font-heading font-black text-3xl md:text-5xl text-background-50 mb-4 leading-tight">
                  明星黑料大全
                </h1>
                <p className="text-base md:text-lg text-background-50/80 mb-6 leading-relaxed">
                  汇聚最新最全明星黑料，深度揭秘娱乐圈内幕、丑闻事件与真相追踪。
                  从流量小生到顶级流量，明星黑料一网打尽，带你看清光鲜背后的真实一面。
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <Link
                    to={`/article/${featuredArticle.id}`}
                    className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-semibold transition-colors text-center whitespace-nowrap cursor-pointer"
                    onClick={handleCategoryClick}
                  >
                    查看今日重磅爆料
                  </Link>
                  <Link
                    to="/about"
                    className="px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/30 rounded-lg text-sm font-medium transition-colors text-center whitespace-nowrap cursor-pointer"
                    onClick={handleCategoryClick}
                  >
                    了解更多
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </header>

        <div className="max-w-7xl mx-auto px-4 md:px-6">

          {/* Featured Articles */}
          <section className="py-10 md:py-14">
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
                今日重磅
              </h2>
              <Link
                to="/category/mingxing-feiwen"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap flex items-center gap-1"
                onClick={handleCategoryClick}
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
              <div className="lg:col-span-2">
                <ArticleCard article={featuredArticle} variant="featured" />
              </div>
              <div className="flex flex-col gap-4">
                {secondaryFeatured.map((article) => (
                  <ArticleCard key={article.id} article={article} variant="horizontal" />
                ))}
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="py-6 md:py-10">
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-6">
              分类浏览
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group flex flex-col items-center gap-3 p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
                  onClick={handleCategoryClick}
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-500 transition-colors">
                    <i className={`${cat.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {cat.name}
                  </span>
                </Link>
              ))}
            </div>
          </section>

          {/* Latest Articles */}
          <section className="py-6 md:py-10">
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
                最新爆料
              </h2>
              <Link
                to="/category/chouwen-baoguang"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap flex items-center gap-1"
                onClick={handleCategoryClick}
              >
                更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {recentArticles.slice(0, 6).map((article) => (
                <ArticleCard key={article.id} article={article} variant="default" />
              ))}
            </div>
          </section>

          {/* Hot & Trending */}
          <section className="py-6 md:py-10 mb-10">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-6">
                  深度揭秘
                </h2>
                <div className="space-y-4">
                  {articles.slice(6).map((article) => (
                    <ArticleCard key={article.id} article={article} variant="horizontal" />
                  ))}
                </div>
              </div>
              <div>
                <div className="bg-background-100 rounded-lg p-5 border border-background-200/70 sticky top-24">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-fire-line text-accent-500 text-lg"></i>
                    </div>
                    <h3 className="font-heading font-bold text-lg text-foreground-950">
                      热门排行
                    </h3>
                  </div>
                  <ol className="space-y-4">
                    {hotArticles.map((article, index) => (
                      <li key={article.id}>
                        <Link
                          to={`/article/${article.id}`}
                          className="flex gap-3 group cursor-pointer"
                          onClick={handleCategoryClick}
                        >
                          <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold ${
                            index < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-300 text-foreground-700'
                          }`}>
                            {index + 1}
                          </span>
                          <div className="min-w-0">
                            <h4 className="text-sm font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                              {article.title}
                            </h4>
                            <p className="text-xs text-foreground-500 mt-1">
                              {article.views >= 100000 ? `${(article.views / 10000).toFixed(1)}万阅读` : `${article.views.toLocaleString()}阅读`}
                            </p>
                          </div>
                        </Link>
                      </li>
                    ))}
                  </ol>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}